import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import { ReservationUtils } from '../../utils';
import { Loading } from '../Loading/Loading';
import { useTripStoreUpdater } from '../../hooks';

interface TripSourceMultiplexerProps {
    onLegacyVacasaTripRender: () => React.ReactElement;
    onPALTripRender: () => React.ReactElement;
    showLoading?: boolean;
}

export const TripSourceMultiplexer: React.FC<TripSourceMultiplexerProps> = ({
    onLegacyVacasaTripRender,
    onPALTripRender,
    showLoading = true,
}) => {
    useTripStoreUpdater(true);
    const trip = useSelector((store: StoreState) => store.trip);

    if (trip.isLoading || !trip.reservation) {
        return showLoading ? (
            <div style={{ marginTop: 200 }}>
                <Loading />
            </div>
        ) : null;
    }

    if (ReservationUtils.isPalManaged(trip.reservation)) {
        return onPALTripRender();
    }
    return onLegacyVacasaTripRender();
};
